<template>
  <div class="public-content special-price">
    <div class="breadcrumb">SKU组特殊价格审核</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="90px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="SKU组名称:">
              <el-input v-model="formInline.skuGroupName" placeholder="请输入SKU组名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称:">
              <el-input v-model="formInline.spuName" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-input v-model="formInline.storeCode" placeholder="请输入平台号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-input v-model="formInline.storeName" placeholder="请输入平台名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.userId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-select v-model="formInline.auditStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="等待审核" value='WAIT_AUDIT'></el-option>
                <el-option label="审核拒绝" value="AUDIT_FAIL"></el-option>
                <el-option label="审核通过" value="AUDIT_SUCCESS"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <!-- <el-button class="search-ok" round>导出Excel</el-button> -->
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="SKU组ID" prop="id"></el-table-column>
          <el-table-column prop="skuGroupName" label="SKU组名称"></el-table-column>
          <el-table-column prop="spuName" label="产品名称"> </el-table-column>
          <el-table-column label="SKU组图片">
            <template v-slot="scope">
              <img style="width:100%" :src="scope.row.skuGroupImage" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="dictSet" label="属性组合"></el-table-column>
          <el-table-column prop="storeCode" label="平台号"></el-table-column>
          <el-table-column prop="storeName" label="平台名称"></el-table-column>
          <el-table-column prop="salesman" label="业务"></el-table-column>
          <el-table-column prop="createdTime" label="申请日期"></el-table-column>
          <el-table-column label="状态">
            <template v-slot="scope">
              <span v-if="$hasPermission('pms:admin:special:audit')" @click="toExamine(scope.row)" class="color-blue"> {{ scope.row.auditStatus === 'AUDIT_SUCCESS' ? '审核通过' : scope.row.auditStatus ===
                'WAIT_AUDIT' ? '等待审核' : scope.row.auditStatus === 'AUDIT_FAIL' ? '审核拒绝' : '未定义' }} </span>
              <span v-else> {{ scope.row.auditStatus === 'AUDIT_SUCCESS' ? '审核通过' : scope.row.auditStatus === 'WAIT_AUDIT' ? '等待审核' : scope.row.auditStatus === 'AUDIT_FAIL' ? '审核拒绝' : '未定义' }} </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo='queryInfo' @changePage="changePage"></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import imgSrc from '@/assets/images/code.svg'
import { getSalesmanByFullName } from '@/api/crm'
import { skuSpecialList, dictListNoPaging, categoryList } from '@/api/pms'
export default {
  name: 'special-price',
  components: {
    VPagination
  },
  inject: ['reload'],
  data () {
    return {
      salemanList: [],
      queryInfo: {
        total: 0,
        pageNum: 1, // 当前显示第几页
        pageSize: 10 // 每一页显示条数
      },
      isShow: false,
      formInline: {
        applyBeginTime: '',
        applyEndTime: '',
        auditStatus: '',
        skuGroupName: '',
        spuName: '',
        storeCode: '',
        storeName: ''
      },
      tableData: [],
      categoryList: [],
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      specialVo: {
        applyBeginTime: '',
        applyEndTime: '',
        auditStatus: '',
        skuGroupName: '',
        spuName: '',
        storeCode: '',
        storeName: ''
      }
    }
  },
  watch: {
    value2 (params) {
      if (params) {
        this.formInline.applyBeginTime = this.$moment(params[0]).format('YYYY-MM-DD')
        this.formInline.applyEndTime = this.$moment(params[1]).format('YYYY-MM-DD')
      } else {
        this.formInline.applyBeginTime = ''
        this.formInline.applyEndTime = ''
      }
    }
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))

      if (this.formInline.applyBeginTime) {
        this.value2 = [this.formInline.applyBeginTime, this.formInline.applyEndTime]
      }
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    // 获取SKU组特殊价格列表
    this.getSkuSpecialList()
    // 获取产品类别列表
    // this.getCategoryList()
  },
  methods: {
    toExamine (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/checkspecial', query: { id: row.id, auditStatus: row.auditStatus, spuProperty: row.spuProperty } })
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    getSkuSpecialList () {
      // skuSpecialList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, specialVo: this.formInline }).then(res => {
      skuSpecialList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, specialVo: this.formInline }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getSkuSpecialList(this.queryInfo)
          }
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
        }
      })
    },
    getCategoryList () {
      categoryList().then(res => {
        if (res.data.success) {
          this.categoryList = res.data.data
        }
      })
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      }
      this.getSkuSpecialList()
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
